type env = 'dev' | 'prod' | 'pre';

export const TokenSignCookie: string = 'production_route/token';
export const PlatCookie: string = 'production_route/plat';
export const ShopCookie: string = 'production_route/curShop';


export const THE_CKB_LINK=process.env.NEXT_PUBLIC_THE_CKB_LINK
export const NEXT_PUBLIC_HELP_CENTER_URL=process.env.NEXT_PUBLIC_HELP_CENTER_URL
